import { Card, CardHeader, CardContent } from '@/components/ui/Card';
import { LineChart } from '@/components/charts/LineChart';
import { useApiLatency } from '@/hooks/useAdminMonitoring';

export function ApiLatencyChart() {
  const { data } = useApiLatency();
  const chartData = (data?.data || []).map((d: { hour: string; avg: number; p99: number }) => ({
    date: d.hour,
    latency: d.avg,
    p99: d.p99,
  }));

  return (
    <Card>
      <CardHeader title="Latence API (24h)" />
      <CardContent>
        <LineChart
          data={chartData}
          lines={[
            { key: 'latency', color: '#3b82f6', label: 'Moyenne (ms)' },
            { key: 'p99', color: '#f59e0b', label: 'P99 (ms)' },
          ]}
          height={250}
        />
      </CardContent>
    </Card>
  );
}
